import type { SubscriptionPlanPricingModel } from '../../types/generated/models/subscription-plan-pricing-model'

export const basicFeatureKeys = [
  'subscription_feature_landing_page',
  'subscription_upgrade_sync_data',
  'subscription_upgrade_manage_projects',
  'subscription_upgrade_create_reports',
  'subscription_upgrade_preconfigure_projects',
  'subscription_upgrade_book_calibration_repair',
  'subscription_upgrade_tester_health_check',
  'subscription_dialog_archiving',
]

export const plusBenefits = [
  {
    featureKey: 'subscription_dialog_geolocation_lock',
    titleKey: 'subscription_upgrade_geolocation',
    descriptionKeys: [
      'subscription_upgrade_geolocation_protect',
      'subscription_upgrade_geolocation_track',
      'subscription_upgrade_geolocation_fleet',
    ],
  },
  {
    featureKey: 'subscription_dialog_analytics_metrics',
    titleKey: 'subscription_upgrade_metrics',
    descriptionKeys: ['subscription_upgrade_metrics_description'],
  },
  {
    featureKey: 'subscription_dialog_smart_flag_filter',
    titleKey: 'subscription_upgrade_smart_flag',
    descriptionKeys: ['subscription_upgrade_smart_flag_description'],
  },
  {
    featureKey: 'subscription_dialog_archiving',
    titleKey: 'subscription_upgrade_auto_archiving',
    descriptionKeys: ['subscription_upgrade_auto_archiving_description'],
  },
]

export const getUpgradeStartingPrice = (
  pricing: SubscriptionPlanPricingModel[] = [],
  preferredCurrency: string = 'GBP'
): { amount: number; currency: string } | null => {
  // The comparison advertises LanTEK and SignalTEK; VDV/PoE billing is unchanged.
  const eligiblePricing = pricing.filter(p =>
    /^(lantek[ _]iv|signaltek)/i.test(p.deviceCategory || '') && p.currency
  )
  const currency = eligiblePricing.find(p => p.currency.toUpperCase() === (preferredCurrency || 'GBP').toUpperCase())?.currency
    || eligiblePricing.find(p => p.currency.toUpperCase() === 'GBP')?.currency
    || eligiblePricing[0]?.currency

  if (!currency) return null

  const prices = eligiblePricing
    .filter(p => p.currency.toUpperCase() === currency.toUpperCase())
    .flatMap(p => [p.price1Device, p.price2To5, p.price6Plus])
    .filter(price => typeof price === 'number' && Number.isFinite(price) && price >= 0)

  return prices.length ? { amount: Math.min(...prices), currency: currency.toUpperCase() } : null
}
